import { useState } from "react";
import InputField from "components/fields/InputField";
import SelectField from "components/fields/SelectField";
import useAuth from "Hooks/useAuth";
import fetchData from "Hooks/useAPI";
import ErrorMessage from "components/ErrorMessage";
import Spinner from "components/spinner";
import { useNavigate } from "react-router-dom";
import { message, Collapse } from 'antd';
import logo_mitaxi from '../../assets/img/logo_mitaxi.png'
const { Panel } = Collapse;





const URL_SIGNUP = "https://adandyou.host/users_app/api/index.php/registro"
const URL_FISCAL = 'https://adandyou.host/users_app/api/index.php/fiscal'


const SignUp = () => {
  const [form, setForm] = useState({
    regimen_fiscal:"601",
    uso_cfdi:"G03"
  })
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const { login, logout } = useAuth()
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage();
  const btnClass = `${error ? 'shake' : ''} linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`;
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response = await fetchData(URL_SIGNUP, 'POST', form, {}, logout);
      const { token, user } = response
      const { email } = user
      login(token, email)
      navigate('/admin')
    } catch (err) {
      console.log(err)
      messageApi.open({
        type: 'error',
        content: "Error al registrarte.Intente de nuevo.",
      });

      setError(error?.response?.data?.message)

    }
    finally {
      setLoading(false)
    }
    try {
      if (form['rfc']) {
        await fetchData(URL_FISCAL, 'POST', form, {}, logout)
        messageApi.open({
          type: 'success',
          content: "Guardado exitosamente",
        });

      }

    } catch (error) {
      console.error(error);
      setError("Error al guardar datos de facturación")
      messageApi.open({
        type: 'error',
        content: "Error al guardar info intente de nuevo.",
      });
    }

  }
  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  }
  const getFormValue = field => form[field]


  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
      {contextHolder}
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <div className="w-full max-w-full flex items-center justify-center">
          <img alt="Mi taxi aeropuerto" src={logo_mitaxi} />
        </div>
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Registrate
        </h4>



        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@simmmple.com"
          id="email"
          type="text"
          onChange={e => handleChange("email", e.target.value)}
          value={getFormValue("email")}
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Contraseña*"
          placeholder="Min. 8 caracteres"
          id="password"
          type="password"
          onChange={e => handleChange("password", e.target.value)}
          value={getFormValue("password")}
        />
        <InputField
          variant="auth"
          extra="mb-3"
          label="Telefono*"
          placeholder="33-333333"
          id="tel"
          type="tel"
          onChange={e => handleChange("telephone", e.target.value)}
          value={getFormValue("telephone")}
        />
        <InputField
          variant="auth"
          extra="mb-3"
          label="Nombre Completo*"
          placeholder="..."
          id="fullname"
          type="text"
          onChange={e => handleChange("name", e.target.value)}
          value={getFormValue("name")}
        />

        <Collapse defaultActiveKey={[]}>
          <Panel header=" Datos de facturación (Opcional)" key="1">
            <InputField
              variant="auth"
              extra="mb-3"
              label="RFC"
              placeholder="..."
              id="rfc"
              type="text"
              onChange={e => handleChange("rfc", e.target.value)}
              value={getFormValue("rfc")}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Razon social"
              placeholder="Mi empresa (sin regimen capital)"
              id="fiscal-name"
              type="text"
              onChange={e => handleChange("razon", e.target.value)}
              value={getFormValue("razon")}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Domicilio Fiscal"
              placeholder="Codigo postal"
              id="fiscal-location"
              type="text"
              onChange={e => handleChange("codigo_postal", e.target.value)}
              value={getFormValue("codigo_postal")}
            />
            <SelectField
              variant="auth"
              extra="mb-3"
              label="Regimen Fiscal"
              id="fiscal-reg"
              onChange={e => handleChange("regimen_fiscal", e.target.value)}
              value={getFormValue("regimen_fiscal")}
            >
              <option value="601">601-General de Ley Personas Morales</option>
              <option value="603">603-Personas Morales con Fines no Lucrativos</option>
              <option value="606">606-Arrendamiento</option>
              <option value="607">607-Régimen de Enajenación o Adquisición de Bienes</option>
              <option value="608">608-Demás ingresos</option>
              <option value="609">609-Consolidación</option>
              <option value="610">610-Residentes en el Extranjero sin Establecimiento Permanente en México
              </option>
              <option value="611">611-Ingresos por Dividendos (socios y accionistas)</option>
              <option value="612">612-Personas Físicas con Actividades Empresariales y Profesionales</option>
              <option value="614">614-Ingresos por intereses</option>
              <option value="615">615-Régimen de los ingresos por obtención de premios</option>
              <option value="616">616-Sin obligaciones fiscales</option>
              <option value="620">620-Sociedades Cooperativas de Producción que optan por diferir sus ingresos
              </option>
              <option value="621">621-Incorporación Fiscal</option>
              <option value="622">622-Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</option>
              <option value="623">623-Opcional para Grupos de Sociedades</option>
              <option value="624">624-Coordinados</option>
              <option value="625">625-Régimen de las Actividades Empresariales con ingresos a través de
                Plataformas Tecnológicas</option>
              <option value="626">626-Régimen Simplificado de Confianza</option>
              <option value="628">628-Hidrocarburos</option>
              <option value="629">629-De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales
              </option>
              <option value="630">630-Enajenación de acciones en bolsa de valores</option>
            </SelectField>
            <SelectField
              variant="auth"
              extra="mb-3"
              label="Uso CFDI"
              id="cfdi-use"
              onChange={e => handleChange("uso_cfdi", e.target.value)}
              value={getFormValue("uso_cfdi")}
            >
              <option value="G03">G03-Gastos en general</option>
              <option value="G01">G01-Adquisición de mercancías</option>
              <option value="G02">G02-Devoluciones, descuentos o bonificaciones</option>
              <option value="G03">G03-Gastos en general</option>
              <option value="I01">I01-Construcciones</option>
              <option value="I02">I02-Mobiliario y equipo de oficina por inversiones</option>
              <option value="I03">I03-Equipo de transporte</option>
              <option value="S01">S01-Sin Efectos Fiscales</option>
            </SelectField>

          </Panel>

        </Collapse>


        <button disabled={loading} onClick={handleSubmit} className={btnClass}>
          {loading ? <Spinner /> : 'Registrar'}
        </button>
        <div className="mt-4">
          {error ? <ErrorMessage text={error} /> : null}
        </div>
        <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            Ya tienes cuenta?
          </span>
          <a
            href="sign-in"
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Inicia sesión
          </a>
        </div>
      </div>
    </div>
  );

}

export default SignUp
